module.exports = __webpack_public_path__ + "0846a3b55f3c0446f5c2a8e86c30e665.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/watch-icon.png
// module id = 1056
// module chunks = 0